import React from 'react'
import _ from 'underscore'
import moment, { tz } from 'moment-timezone'

import Spinner from 'components/Spinner'
import Plot from 'pages/Device/ThermostatRthPanel/Chart/Plot'
import GoRthCycles from 'pages/Device/ThermostatRthPanel/GoRthCycles'

import { usePremiumFeaturesContext } from 'hooks/PremiumFeaturesContext'

import { RuntimeHistory } from 'types/RuntimeHistory'
import { NoData } from 'styles/shared'

const DATE_FORMAT = 'YYYY-MM-DD'
const STANDARD_USER_MIN_DATE = moment().subtract(30, 'days').format(DATE_FORMAT)

type ServerlessRthChartProps = {
  rthDate: string
  startTime?: string
  endTime?: string
  timeZone: string
  deviceId: string
  isZoomed: boolean
  isControlHub: boolean
  showFullScreen: boolean
  zoomedCallback: (val: boolean) => void
  freezeMouseHover: boolean
  freezeMouseHoverCallback: (val: boolean) => void
  updateSelectedLegendsCallback: (val: unknown) => void
  isRTHDataLoaded: boolean
  rthData: RuntimeHistory | null
  reportCache?: Record<string, unknown>
  isHehm?: boolean
}

const ServerlessRthChart = ({
  rthDate,
  timeZone,
  deviceId,
  isControlHub,
  isZoomed,
  zoomedCallback,
  showFullScreen,
  freezeMouseHover,
  freezeMouseHoverCallback,
  updateSelectedLegendsCallback,
  rthData,
  isRTHDataLoaded,
  reportCache = {},
  isHehm = false
}: ServerlessRthChartProps) => {
  const startTime = tz(`${rthDate}`, 'YYYY-MM-DD', timeZone).startOf('day').format('YYYY-MM-DD HH:mm:ss')
  const endTime = tz(`${rthDate}`, 'YYYY-MM-DD', timeZone).endOf('day').format('YYYY-MM-DD HH:mm:ss')

  const { showUpgrade, showFeature } = usePremiumFeaturesContext()

  if (!isRTHDataLoaded) {
    return <Spinner variant="page" />
  }

  if (moment(startTime).isBefore(STANDARD_USER_MIN_DATE) && (!showFeature('extended_rthg') || showUpgrade('extended_rthg'))) {
    return (
      <NoData>
        <h1>Upgrade to Diagnostics Premium for extended Runtime Data</h1>
      </NoData>
    )
  } else {
    return (
      <>
        <Plot
          deviceId={deviceId}
          rthData={rthData}
          isControlHub={isControlHub}
          isHehm={isHehm}
          startTime={startTime}
          endTime={endTime}
          timeZone={timeZone}
          isZoomed={isZoomed}
          zoomedCallback={zoomedCallback}
          showFullScreen={showFullScreen}
          freezeMouseHover={freezeMouseHover}
          updateSelectedLegendsCallback={updateSelectedLegendsCallback}
          freezeMouseHoverCallback={freezeMouseHoverCallback}
          chartDivId="plotly-serverless-rth-chart"
          reportCache={reportCache}
        />
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {!_.isEmpty(rthData?.stages) && <GoRthCycles stages={(rthData as RuntimeHistory).stages as any} accessories={(rthData as any).accessories} isHehm={isHehm} />}
      </>
    )
  }
}

export default ServerlessRthChart
